import { render, staticRenderFns } from "./formV2.vue?vue&type=template&id=88c4b144&scoped=true"
import script from "./formV2.vue?vue&type=script&lang=js"
export * from "./formV2.vue?vue&type=script&lang=js"
import style0 from "./formV2.vue?vue&type=style&index=0&id=88c4b144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c4b144",
  null
  
)

export default component.exports